<template>
    <AttachListDialog
            :dialogTitle="'附件列表'"
            :centerDialogVisible="visible"
            @updateVisible="updateVisible"
            @resetPopupData="resetPopupData"
            @submitPopupData="submitPopupData"
            :popupWidth="'1000px'"
            :showBtn="false"
    >

        <TableList :table-data="tableData" :table-label="tableLabel" :loading="loading"
                   :selection-show="multipleSelection" >
            <template v-slot:operate="slot">
                <el-button type="text" @click="checkAttach(slot.scope.row)">查看附件</el-button>
            </template>
        </TableList>

        <div class="pagination">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]" layout="total, sizes, prev, pager, next, jumper"
                           :current-page="pager.currentPage" :page-size="pager.pageSize"
                           :total="pager.pageTotal" prev-text="上一页" next-text="下一页">
            </el-pagination>
        </div>

        <div style="width: 100%; text-align: center;margin-top: 20px">
            <el-button @click="resetPopupData">关闭</el-button>
        </div>
    </AttachListDialog>
</template>

<script>
    import AttachListDialog from "../../../../../components/common/epecDialog";
    import TableList from "../../common/e-table-list";
    import agreementApi from "../../../api/agreement/index";
    export default {
        name: "attachListDialog",
        components: {
            AttachListDialog,
            TableList,
        },
        props: {
            visible: {
                type: Boolean,
                required: true,
            },
            agreementId:{
                type: String,
                required: true
            }
        },
        data() {
            return {
                loading: false,
                tableData: [],
                tableLabel: [
                    {
                        label: "附件名称",
                        param: "attachmentName",
                        align: "center"
                    },
                    {
                        label: "上传时间",
                        param: "attachmentUploadTime",
                        align: "center"
                    },
                    {
                        label: "操作",
                        align: "center",
                        slot: "operate"
                    },
                ],
                pager: {
                    currentPage: 1,
                    pageSize: 10,
                    pageTotal: 0,
                },
                multipleSelection: false,
            };
        },
        computed: {},
        created() {
            this.getAttachmentList();
        },
        methods: {
            handleSearch() {
                this.getAttachmentList();
            },
            handleClear() {
                this.query.skuName = "";
                this.query.skuCode = "";
            },
            handleSizeChange(val) {
                this.pager.currentPage=1;
                this.pager.pageSize = val;
                this.getAttachmentList();
            },
            handleCurrentChange(val) {
                this.pager.currentPage = val;
                this.getAttachmentList();
            },
            updateVisible() {},
            resetPopupData() {
                this.$emit("close");
            },
            submitPopupData() {
                this.$emit('close')
            },
            getAttachmentList() {
                let params = {
                    agreementId: this.agreementId,
                    pageNum:this.pager.currentPage,
                    pageSize:this.pager.pageSize,
                }
                agreementApi.getAttachmentList(params).then((res) => {
                    if (res.data) {
                        this.tableData = res.data.records;
                        this.pager.pageTotal = res.data.total;
                    }
                });
            },
            checkAttach(val){
                window.open(val.attachmentPath)
            }
        },
    };
</script>

<style lang="scss" scoped>
    .el-dialog {
        display: flex;
        flex-direction: column;
        margin: 0 !important;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        /*height:600px;*/
        max-height: calc(100% - 30px);
        max-width: calc(100% - 30px);
    }

    .el-dialog .el-dialog__body {
        flex: 1;
        overflow: auto;
    }
</style>
